SAPO.namespace('Project.Video');

SAPO.Project.Video.play = function(oo) {

    'use strict';


    /**
     * This is the code controlling VideoHighEnd. It is responsible for creating the isolation iframe and wiring all stuff up
     */

    /*global SV_HOST:true, SV_VERSION:true */


    var container = oo.container;

    if (!oo.iframeClass) {          oo.iframeClass          = 'sapo_videos_player'; }
    if (!oo.iframeMaximizedClass) { oo.iframeMaximizedClass = 'fullScreen';         }

    var ifrCls = oo.iframeClass;


    var masterRule = function(el, recurse) {
        var rules = [];
        var rule = [];
        var nodeName, id, classes;

        do {
            nodeName = el.nodeName.toLowerCase();

            if (nodeName === 'html') { break; }

            rule.push(nodeName);

            id = el.id;
            if (id) {
                rule = rule.concat(['#', id]);
            }

            classes = el.className;
            if (classes) {
                classes = classes.split(' ');
                rule = rule.concat(['.', classes.join('.')]);
            }

            rules.unshift( rule.join('') );
            rule = [];

            el = el.parentNode;
        } while (el && recurse);

        return rules.join(' ');
    };


    // patch parent window's CSS
    //if (!oo.skipCssPatch) {
        var cssCb = function() {
            var pWindow, pDocument;

            try {
                pWindow = window.parent;
                pDocument = pWindow.document;
                if (!pDocument) { return; }
            } catch (ex) { return; }

            var containerEl = s$(container);

            var containerMasterRule = masterRule(containerEl);

            /*console.log('ifrCls',       ifrCls);
            console.log('ifrMaxCls',    ifrMaxCls);
            console.log('containerSel', containerSel);*/

            var t = '    ';
            var css = [
                containerMasterRule + ' .' + ifrCls + ' {',
                    t+'width: 100%;',
                    t+'height: 100%;',
                '}',
                containerMasterRule + '.error {',
                    t+'position: absolute;',
                    t+'width:  100%;',
                    t+'height: 100%;',
                    t+'color: #AAA;',
                '}',
                containerMasterRule + '.error .reason {',
                    t+'position: absolute;',
                    t+'width: 100%;',
                    t+'height: 100%;',
                    t+'left: 0;',
                    t+'top: 50%;',
                    t+'text-align: center;',
                    t+'margin-top: -0.5em;',
                    t+'font-size: 1em;',
                '}'
            ].join('\n');
            //console.log(css);

            var styleEl = pDocument.createElement('style');
            styleEl.setAttribute('type', 'text/css');

            var pHeadEl = pDocument.getElementsByTagName('head')[0];
            pHeadEl.appendChild(styleEl);

            if (styleEl.styleSheet) { // IE
                styleEl.styleSheet.cssText = css;
            }
            else {
                styleEl.appendChild( document.createTextNode(css) );
            }

            //console.log('cssCb has been run');
        };


        setTimeout(cssCb, 0);
    //}



    var scriptEl = /*document.currentScript ||*/ document.querySelector('[data-sapo-videos-player]');
    // console.log(scriptEl);

    var attributes = scriptEl.getAttribute('data-sapo-videos-player').split(' ');
    // console.log(attributes);
    SV_HOST    = attributes[0];
    SV_PATH    = attributes[1];
    SV_VERSION = attributes[2];

    if (oo.playerInterno) {
        oo.staticGUI    = true;
        oo.skipBranding = true;
    }

    var tmpOptionsVar = 'tmp' + ~~( Math.random() * 10000 );
    window[tmpOptionsVar] = oo;

    var onReadyCallbackName = 'ready' + ~~( Math.random() * 10000 );


    // customCss and customCssMode options handling
    var tmp, stylePart = '<link rel="stylesheet" type="text/css" href="//' + SV_PATH + '/css/video.min.css">';
    if (oo.customCss) {
        if (oo.customCss.indexOf('.') === -1) { // id
            tmp = document.getElementById(oo.customCss);
            if (tmp) {
                tmp = tmp.innerHTML;
                tmp = '<style type="text/css">' + tmp + '</style>';
            }
        }
        else { // URL
            tmp = '<link rel="stylesheet" type="text/css" href="' + oo.customCss + '">';
        }

        if (oo.customCssMode === 'replace') {
            stylePart = tmp;
        }
        else {
            stylePart += '\n' + tmp;
        }
    }
    //console.log('stylePart:\n', stylePart);

    new SAPO.Utility.IframeWrapper({
        name: 'Player SAPO Vídeos',
        container: container,

        className: ifrCls,

        onReadyCallbackName: onReadyCallbackName,

        markup: [
            '<!DOCTYPE html>',
            '<html>',
                '<head>',
                    '<meta charset="utf-8">',
                    '<link rel="dns-prefetch" href="//' + SV_HOST + '">',
                    '<meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no">',
                    '<meta http-equiv="X-UA-Compatible" content="IE=edge">',

                    stylePart,

                    '<style type="text/css" id="poster-css"></style>',
                    '<style type="text/css" id="subtitles-css"></style>',

                    '<script type="text/javascript">',
                        'window.SV_HOST    = \'' + SV_HOST    + '\';',
                        'window.SV_VERSION = \'' + SV_VERSION + '\';',
                        'window.SV_PATH    = \'' + SV_PATH    + '\';',
                    '</script>',

                    '<script type="text/javascript" src="//' + SV_PATH + '/VideoHighEndInner.js"></scr'+'ipt>',
                '</head>',

                '<body>',
                    '<script type="text/javascript" id="tmpScript">',
                        '(function() {',
                            'var o = window.parent.' + tmpOptionsVar + ';',
                            'try { delete window.parent.' + tmpOptionsVar + '; } catch (ex) {}',
                            'var v = SAPO.Project.Video.play(o);',
                            'window.parent.' + onReadyCallbackName + '(v);',
                            'try { delete window.parent.' + onReadyCallbackName + '; } catch (ex) {}',
                            'if (o.onReady) { v.subscribe("impl_ready", function(){ o.onReady(v); }) }',
                            'document.body.removeChild(document.getElementById("tmpScript"));',
                        '})();',
                    '</scr'+'ipt>',
                '</body>',
            '</html>'
        ].join('\n')
    });

};
